import React, { FC } from "react";

import {
  DetailsList,
  DetailsListItem,
} from "@UI/Components/DetailsList/DetailsList";
import { FooterLink } from "./FooterLink";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "./messages";

export const FooterLeftLinks: FC = () => {
  return (
    <DetailsList title={<FormattedMessage {...messages.discover} />}>
      <DetailsListItem>
        <FooterLink
          color="gray.700"
          route="BECOME_SERVICE_PROVIDER"
          reloadDocument
        >
          <FormattedMessage {...messages.becomeServiceProvider} />
        </FooterLink>
      </DetailsListItem>
      <DetailsListItem>
        <FooterLink color="gray.700" route="REQUEST_SERVICE" reloadDocument>
          <FormattedMessage {...messages.requestAService} />
        </FooterLink>
      </DetailsListItem>
      <DetailsListItem>
        <FooterLink
          color="gray.700"
          route="BEST_SERVICE_PROVIDERS"
          reloadDocument
        >
          <FormattedMessage {...messages.bestServiceProviders} />
        </FooterLink>
      </DetailsListItem>
      <DetailsListItem>
        <FooterLink color="gray.700" route="SHARE" reloadDocument>
          <FormattedMessage {...messages.inviteYourFriends} />
        </FooterLink>
      </DetailsListItem>
    </DetailsList>
  );
};
